import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=024f4b66&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=024f4b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f4b66",
  null
  
)

export default component.exports